import { MODULES } from "@colossus/contracts/module";
import type { Module } from "@colossus/contracts/module";
import type { Message } from "./locale.ts";
import { m } from "./paraglide/messages.js";
import type { IconName } from "./ui/icons.ts";

export { MODULES };
export type { Module };

export const MODULE_TITLE: Readonly<Record<Module, Message>> = {
  analytics: m.module_analytics,
  intelligence: m.module_intelligence,
  rewards: m.module_rewards,
  campaigns: m.module_campaigns,
  workspace: m.module_workspace,
};

export const MODULE_ICON: Readonly<Record<Module, IconName>> = {
  analytics: "analytics",
  intelligence: "intelligence",
  rewards: "rewards",
  campaigns: "campaigns",
  workspace: "workspace",
};

export const PINNED_MODULE: Module = "workspace";
